export const getSupportedCharacters = ( state ) => {
    return state.supportedCharacters;
}
